import { collection, query, getCountFromServer } from "firebase/firestore";
import { ListServiceOpts } from "../../types";
import { db } from "../../firebase";

export type ChildCountService = (
  userId: string,
  opts?: ListServiceOpts
) => Promise<number>;

const count: ChildCountService = async (userId, opts = {}) => {
  const collectionRef = collection(db, `/user/${userId}/child`);
  const q =
    typeof opts.listQueryFn === "function"
      ? opts.listQueryFn(collectionRef)
      : query(collectionRef);
  const snapshot = await getCountFromServer(q);

  return snapshot.data().count;
};

export default count;
